import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "./components/Home.jsx";
import Navbar from "./components/Navbar";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SubirDocumento from "./components/SubirDocumento";
import ListaCasos from "./components/ListaCasos";
import ResultadoDiagnosticoPage from "./pages/ResultadoDiagnosticoPage";
import InformeFinalPage from "./pages/InformeFinalPage";
import IngresoCasoPage from "./pages/IngresoCasoPage";
import IngresoMuestraPage from "./pages/IngresoMuestraPage";
import BiologiaMolecularPage from "./pages/BiologiaMolecularPage";
import BiologiaMolecularDashboardPage from "./pages/BiologiaMolecularDashboardPage";
import ParasitologiaDoseResponsePage from "./pages/ParasitologiaDoseResponsePage";
import PackToroPage from "./pages/PackToroPage";
import VistaMuestras from "./components/VistaMuestras";
import ListaUsuarios from "./components/ListaUsuarios";
import LoginForm from "./components/LoginForm";
import CasosDashboardPage from "./pages/CasosDashboardPage";
import DashboardProtectedRoute from "./components/DashboardProtectedRoute";
import PermissionsProtectedRoute from "./components/PermissionsProtectedRoute";
import AuditProtectedRoute from "./components/AuditProtectedRoute";
import AdminProtectedRoute from "./components/AdminProtectedRoute";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import PermisosPage from "./pages/PermisosPage";
import AuditoriaPage from "./pages/AuditoriaPage";

function GlobalPageLoader({ visible }) {
  return (
    <div
      className={`page-loader${visible ? " page-loader--visible" : ""}`}
      aria-hidden={!visible}
    >
      <div className="page-loader__ring" />
    </div>
  );
}

function AppContent() {
  const location = useLocation();
  const [isPageLoading, setIsPageLoading] = useState(true);
  const isLoginPage = location.pathname === "/login";

  useEffect(() => {
    setIsPageLoading(true);

    const timeoutId = window.setTimeout(() => {
      setIsPageLoading(false);
    }, 850);

    return () => window.clearTimeout(timeoutId);
  }, [location.pathname]);

  return (
    <div className="app-shell">
      <GlobalPageLoader visible={isPageLoading} />
      {!isLoginPage ? <Navbar /> : null}
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="app-layout">
        <main className="app-main">
          <Routes>
            <Route path="/login" element={<LoginForm />} />
            <Route
              element={<AuthenticatedRoute />}
            >
              <Route path="/" element={<Home />} />
              <Route path="/ingreso-caso" element={<IngresoCasoPage />} />
              <Route path="/editar-caso/:protocoloGeneral" element={<IngresoCasoPage />} />
              <Route path="/ingreso-muestra" element={<IngresoMuestraPage />} />
              <Route path="/editar-muestra/:protocoloMuestra" element={<IngresoMuestraPage />} />
              <Route path="/biologia-molecular" element={<BiologiaMolecularPage />} />
              <Route path="/parasitologia/dosis-respuesta" element={<ParasitologiaDoseResponsePage />} />
              <Route path="/pack-toro" element={<PackToroPage />} />
              <Route path="/pack-toro/:protocolo" element={<PackToroPage />} />
              <Route
                path="/biologia-molecular/dashboard"
                element={(
                  <DashboardProtectedRoute>
                    <BiologiaMolecularDashboardPage />
                  </DashboardProtectedRoute>
                )}
              />
              <Route
                path="/biologia-molecular/ensayo/:ensayoNumero/cierre"
                element={<BiologiaMolecularPage mode="closure" />}
              />
              <Route path="/biologia-molecular/ensayo/:ensayoNumero" element={<BiologiaMolecularPage />} />
              <Route path="/subir-documento" element={<SubirDocumento />} />
              <Route path="/ver-casos" element={<ListaCasos />} />
              <Route path="/ver-caso/:protocoloGeneral" element={<VistaMuestras />} />
              <Route
                path="/dashboard-casos"
                element={(
                  <DashboardProtectedRoute>
                    <CasosDashboardPage />
                  </DashboardProtectedRoute>
                )}
              />
              <Route
                path="/permisos"
                element={(
                  <PermissionsProtectedRoute>
                    <PermisosPage />
                  </PermissionsProtectedRoute>
                )}
              />
              <Route
                path="/auditoria"
                element={(
                  <AuditProtectedRoute>
                    <AuditoriaPage />
                  </AuditProtectedRoute>
                )}
              />
              <Route path="/resultado-diagnostico" element={<ResultadoDiagnosticoPage />} />
              <Route path="/editar-resultado/:resultadoId" element={<ResultadoDiagnosticoPage />} />
              <Route path="/informe-final" element={<InformeFinalPage />} />
              <Route path="/informe-final/:protocoloGeneral" element={<InformeFinalPage />} />
              <Route path="/ver-muestras/:protocoloGeneral" element={<VistaMuestras />} />
              <Route
                path="/usuarios"
                element={(
                  <AdminProtectedRoute>
                    <ListaUsuarios />
                  </AdminProtectedRoute>
                )}
              />
            </Route>
          </Routes>
        </main>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
